import { render, staticRenderFns } from "./service-order-display.vue?vue&type=template&id=6d97b7a0&scoped=true"
import script from "./service-order-display.vue?vue&type=script&lang=js"
export * from "./service-order-display.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d97b7a0",
  null
  
)

export default component.exports